function divide(a, b) {
  return a / b;
}

divide.op = '/';

export default divide;
